import styled from 'styled-components';

import { ActionButton, LinkButton } from 'components/ui/Button';
import { ButtonContent } from 'components/ui/Button/Button.styles';

import { colours } from 'themes/default';

export const StyledActionButton = styled(ActionButton)`
  color: ${colours.Shades.BlueShade40};
  margin-right: 20px;

  ${ButtonContent} {
    > :first-child {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }
`;

export const StyledLinkButton = styled(LinkButton)`
  color: ${colours.Shades.BlueShade40};

  ${ButtonContent} {
    > :first-child {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }
`;

export const RowHeader = styled('h2')`
  font-size: 28px;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
`;

export const StyledRow = styled.div`
  padding: 0 16px 16px;
`;
